// 物料分类
export const materialClassification = [
    {
        label: "主物料",
        value: "主物料"
    }, {
        label: "包材",
        value: "包材"
    }, {
        label: "配件",
        value: "配件"
    }, {
        label: "随机文件",
        value: "随机文件"
    }, {
        label: "辅料",
        value: "辅料"
    },
]

export const bomColumns = [
    {
        title: "编码",
        dataIndex: "materialCode",
        align: "left",
        width: "260px",
        fixed: "left",
    },
    {
        title: "物料名称",
        dataIndex: "materialName",
        width: "160px",
        align: "center",
        fixed: "left",
    },
    {
        title: "分类",
        dataIndex: "materialSort",
        align: "center",
        width: "80px",
    },
    {
        title: "型号",
        dataIndex: "materialModel",
        align: "center",
        width: "160px",
    },
    {
        title: "规格",
        dataIndex: "specification",
        width: "160px",
        align: "center",
    },
    {
        title: "属性",
        dataIndex: "attribute",
        align: "center",
        width: "120px",
    },
    {
        title: "版本",
        dataIndex: "edition",
        align: "center",
        width: "80px",
    },
    {
        title: "代码",
        dataIndex: "code",
        align: "center",
        width: "80px",
    },
    {
        title: "单位",
        dataIndex: "unit",
        align: "center",
        width: "80px",
    },
    {
        title: "系列1数量",
        dataIndex: "seriesOneQuantity",
        align: "center",
        width: "80px",
    },
    {
        title: "系列2数量",
        dataIndex: "seriesTwoQuantity",
        align: "center",
        width: "80px",
    },
    {
        title: "系列3数量",
        dataIndex: "seriesThreeQuantity",
        align: "center",
        width: "80px",
    },
    {
        title: "系列4数量",
        dataIndex: "seriesFourQuantity",
        align: "center",
        width: "80px",
    },
    {
        title: "备注",
        dataIndex: "notes",
        width: "160px",
        align: "center",
    },
    {
        title: "检验",
        align: "center",
        width: "80px",
        slots: {
            customRender: "inspect",
        },
    },
    {
        title: "操作",
        align: "center",
        slots: {
            customRender: "action",
        },
        fixed: "right",
        width: "140px",
    },
];

